import { useEffect, useState } from 'react';
import { ContentBlock, ContentGrid } from 'components/layout/contentGrid';
import { ContentCard } from 'components/layout/contentCard/contentCard';
import { Text } from 'components/text';
import { useApi } from 'hooks/useApi';
import { useTranslator } from 'hooks/useTranslator';
import { Loader } from 'components/common/loader';
import { ErrorBoundary } from 'components/common/errorBoudry';

export const PrivacyPage = () => {
    const getText = useApi('/block/privacy');
    const [text, setText] = useState();
    const translator = useTranslator();

    useEffect(() => {
        const request = async () => {
            const res = await getText();
            const data = await res.json();
            setText(data.text);
        };
        if (!text) {
            request();
        }
    }, [text, setText, getText]);

    const getTextBlock = () => {
        return (
            <div
                className={'text'}
                dangerouslySetInnerHTML={{ __html: translator(text) }}
            />
        );
    };

    return (
        <ErrorBoundary boundary="privacy">
            <ContentGrid>
                <ContentBlock>
                    <ContentCard header title={<Text k={`Privacy Policy`} />}>
                        {text ? getTextBlock() : <Loader />}
                    </ContentCard>
                </ContentBlock>
            </ContentGrid>
        </ErrorBoundary>
    );
};
